import BookItem from "../common/bookItem";
export default class MutualSoundAfileGroupChild extends BookItem {
    constructor(el, target) {
        super(el, target);
        this.el = el;
        this.connectNumber = this.el.connectNumber;
        this.initialVisible = this.el.initialVisible;
        // this.add_mouse_event();
    }

    init() {
        if (this.initialVisible == true) {
            this.target.visible = true;
        }
        else {
            this.target.visible = false;
            this.target.children.forEach(element => {
                element.mouseEnabled = false;
            });
        }
    }
}